import styled from '@emotion/styled'

export const StyledTextArea = styled.textarea`
    width: 560px;
    height: 200px;
    overflow: 'auto';
    fontfamily: 'monospace';
`
